/**
 * Palvelun nimi yhdessä paikassa. Kaikki käyttäjälle näkyvät tekstit (sovellus, sähköpostit,
 * PDF:t) käyttävät tätä. Käännöksissä nimi on muuttuja {{app}} ja heikko vartalo {{appWeak}}.
 *
 * Suomen taivutus tehdään liittämällä pääte nimen perään. Vuokrantti taipuu kuten Antti,
 * joten osa muodoista tehdään heikosta vartalosta (tt -> t):
 *   vahva  APP_NAME:      Vuokrantti, Vuokranttia, Vuokranttiin  (`${APP_NAME}a`, `${APP_NAME}in`)
 *   heikko APP_NAME_WEAK: Vuokrantin, Vuokrantissa, Vuokrantista, Vuokrantilla, Vuokrantille
 *                         (`${APP_NAME_WEAK}n`, `${APP_NAME_WEAK}ssa`, ...)
 * Jos nimi vaihtuu, tarkista molemmat vakiot.
 *
 * Huom. kotisivu (apps/site/index.html) on staattinen: vaihda nimi sinne käsin.
 */
export const APP_NAME = 'Vuokrantti';
export const APP_NAME_WEAK = 'Vuokranti';
